export const bootstrap = () => {
    const iOSArElement = document.createElement('a');
    iOSArElement.id = 'ar-link';
    iOSArElement.rel = 'ar';
    iOSArElement.download = 'model.usdz';
    iOSArElement.setAttribute('style', 'position: absolute;');
    iOSArElement.appendChild(document.createElement('img'));
    document.body.appendChild(iOSArElement);
    return iOSArElement;
};

export function loadAR(
    modelUrl: string,
    iOSArElement: HTMLAnchorElement,
    onAddToCart?: () => void,
) {
    const bannerUrl = new URL('assets/arBanner.html', document.location.href);
    const inAppExperienceMeta = onAddToCart ? encodeURI(`#custom=${bannerUrl}`) : '';

    const url = `${modelUrl}${inAppExperienceMeta}`;
    iOSArElement.href = url;

    onAddToCart &&
        iOSArElement.addEventListener('message', event => {
            if (event && (event as MessageEvent).data === '_apple_ar_quicklook_button_tapped') {
                onAddToCart();
            }
        });

    iOSArElement.click();
}
